import { Component, EventEmitter, Input, Output } from '@angular/core';
import { buildDashboardThemeVars, DashboardAccent } from '../dashboard-widget-theme';

export interface DashboardStatBucket {
	label: string;
	count: number;
	data?: any[];
	/** Optional consumer-defined id so bucketView handlers can tell buckets apart. */
	key?: string;
}

@Component({
	selector: 'app-dashboard-stat-card',
	templateUrl: './dashboard-stat-card.component.html',
	styleUrls: ['./dashboard-stat-card.component.scss'],
})
export class DashboardStatCardComponent {
	@Input() title = '';
	@Input() icon = 'info_outline';
	@Input() accent: DashboardAccent = 'primary';
	@Input() value: string | number | null = null;
	@Input() loading = false;
	@Input() showView = true;
	@Input() buckets: DashboardStatBucket[] = [];

	@Output() view = new EventEmitter<void>();
	@Output() bucketSelect = new EventEmitter<any[]>();
	/** Emits the clicked bucket itself — for consumers that key off label/key
	 *  rather than a prefiltered data array (bucketSelect's contract). */
	@Output() bucketView = new EventEmitter<DashboardStatBucket>();

	get themeVars(): Record<string, string> {
		return buildDashboardThemeVars('dsc', this.accent);
	}

	onIconClick(): void {
		this.view.emit();
	}

	onViewClick(): void {
		this.view.emit();
	}

	trackBucket(index: number, bucket: DashboardStatBucket): string {
		return bucket.key || bucket.label;
	}

	onBucketClick(bucket: DashboardStatBucket): void {
		if (this.bucketView.observers.length > 0) {
			this.bucketView.emit(bucket);
		} else if (bucket.data?.length) {
			this.bucketSelect.emit(bucket.data);
		} else {
			this.view.emit();
		}
	}
}
